import script from "./BirthdayMain.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthdayMain.vue?vue&type=script&setup=true&lang=js"

import "./BirthdayMain.vue?vue&type=style&index=0&id=ff9a2622&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_d0e91f904bb1d11c0b68168201cc497f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff9a2622"]])

export default __exports__